import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Map',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "8.5", y1: "19.5", x2: "8.5", y2: "13.5" }
      }), h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M8.5 8.51V3.5" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "15.5", y1: "5.5", x2: "15.5", y2: "12.5" }
      }), h("polygon", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", points: "8.5,19.5 1.5,21.5 1.5,5.5 8.5,3.5 15.5,5.5 22.5,3.5 22.5,19.5 15.5,21.5" }
      }), h("path", {
        attrs: { d: "M10.23 11.12c-.22-.16-.54-.11-.7.12s-.11.54.12.7l1.55 1.1c.09.06.19.09.29.09a.5.5 0 0 0 .29-.91l-1.55-1.1zm-2.1-.98l-1.63.98a.502.502 0 1 0 .52.86L8.65 11a.502.502 0 1 0-.52-.86zm-3.26 1.95l-1.63.98c-.24.14-.31.45-.17.69.1.15.26.24.43.24.09 0 .18-.02.26-.07l1.63-.98c.24-.14.31-.45.17-.69a.511.511 0 0 0-.69-.17zm12.4 1.35l-1.48 1.19c-.22.17-.25.49-.08.7.1.12.24.19.39.19.11 0 .22-.04.31-.11l1.48-1.19c.22-.17.25-.49.08-.7a.504.504 0 0 0-.7-.08zm-3.95-.11a.5.5 0 0 0-.7.12.5.5 0 0 0 .12.7l1.55 1.1c.09.06.19.09.29.09a.5.5 0 0 0 .29-.91l-1.55-1.1zm6.87-2.22l-1.43 1.15c-.22.17-.25.49-.08.7.1.12.24.19.39.19.11 0 .22-.04.31-.11l1.43-1.15c.22-.17.25-.49.08-.7a.496.496 0 0 0-.7-.08z" }
      })]
    );
  }
};